import { ReportHandlerFactory } from "./handlers/ReportHandlerFactory";

/**
 * Generates and downloads a PDF report from standardized report data.
 * Refactored to use Strategy pattern via ReportHandlerFactory.
 */
export const downloadAccountingPdf = async (jsonContent) => {
    if (!jsonContent) return;

    try {
        const handler = ReportHandlerFactory.getHandler(jsonContent);
        await handler.downloadPdf();
    } catch (error) {
        console.error("Error generating PDF report:", error);
    }
};

/**
 * Generates and returns a PDF blob for the report.
 */
export const generateAccountingPdfBlob = async (jsonContent) => {
    if (!jsonContent) return null;

    try {
        const handler = ReportHandlerFactory.getHandler(jsonContent);
        const pdfDoc = await handler.downloadPdf(false);
        return new Promise((resolve) => {
            pdfDoc.getBlob((blob) => {
                resolve(blob);
            });
        });
    } catch (error) {
        console.error("Error generating PDF blob:", error);
        return null;
    }
};
